import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { Trans } from 'react-i18next';
import { useCustomTranslation } from '../../../../../hooks';

const KanbanPendingToDoModal = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.kanban.modals.plannedTODO');

  return (
    <StaticModal isOpen onClose={closeKanbanPendingToDoModal}>
      <StaticModal.Header withCloseButton>{tWrapper('header')}</StaticModal.Header>
      <StaticModal.Content>
        <div className="flex flex-col gap-y-6">
          {/* <LotInfo active={action.active} /> */}
          <span className="text-s18">
            <Trans components={{ strong: <strong /> }}>{tWrapper('description')}</Trans>
          </span>
          <span className="text-s18">{tWrapper('additionalInfo')}</span>
        </div>
      </StaticModal.Content>
      <StaticModal.Footer>
        {/* <Button variant="outlined" onClick={onConfirm}>
          {tWrapper('confirm')}
        </Button> */}
        <Button variant="contained" onClick={closeKanbanPendingToDoModal}>
          {tWrapper('cancel')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openKanbanPendingToDoModal, closeKanbanPendingToDoModal } = createModal(KanbanPendingToDoModal, {
  name: 'KanbanPendingToDoModal',
});
